/**
 * Standalone, Keycloak-free return page for embedded signing (D-11, handover §5).
 *
 * Runs in main.tsx BEFORE — and INSTEAD OF — the normal bootstrap for
 * `/agreements/{contractId}/signing/{done|declined|closed}`. signNow navigates the signing iframe
 * itself here (`redirect_target: self`); the authenticated SPA redirected that frame to Keycloak,
 * which cannot render in a frame (S-3). Same pattern as verify-standalone, signup-standalone and
 * oauth-callback-standalone: no Router, no AuthProvider, no QueryClient, no API call.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { SigningReturnOutcome } from '@/lib/contracts/signing-return-message';
import { relaySigningReturn } from './relay-signing-return';
import { SigningReturnApp } from './SigningReturnApp';

export function runSigningReturnApp(outcome: SigningReturnOutcome): void {
  const relay = relaySigningReturn(outcome);
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <SigningReturnApp outcome={outcome} relay={relay} />
    </StrictMode>,
  );
}
